import React from 'react';

const ReavaliacaoSeguroAutoIBX: React.FC = () => {
  return (
    <section className="relative bg-[#f5f5f7] py-12 sm:py-16 lg:py-24 overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-[0.025] pointer-events-none">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(rgba(0,0,0,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.04) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
      </div>

      {/* Light glows */}
      <div className="absolute top-0 right-0 w-[420px] h-[420px] bg-blue-50/70 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[320px] h-[320px] bg-slate-200/50 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto px-5 sm:px-6 lg:px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-14 items-center min-h-[500px] lg:min-h-[760px]">
          {/* COLUNA ESQUERDA */}
          <div className="space-y-5 sm:space-y-6 lg:space-y-7">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-full px-4 py-2">
              <i className="ri-car-line text-blue-600 text-sm sm:text-base" />
              <span className="text-blue-700 font-bold text-[10px] sm:text-xs tracking-[0.18em] uppercase">
                Reavaliação auto
              </span>
            </div>

            {/* Título */}
            <h2 className="text-[30px] sm:text-[36px] lg:text-[48px] xl:text-[54px] font-bold text-slate-900 leading-[1.05] tracking-[-0.02em] max-w-[720px]">
              Você já pode{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-500">
                reavaliar financeiramente
              </span>{' '}
              o seguro do seu carro.
            </h2>

            {/* Texto */}
            <p className="text-slate-600 text-[15px] sm:text-[17px] lg:text-[19px] leading-[1.65] max-w-[680px]">
              Reavaliar financeiramente o seguro do seu carro é importante não apenas para reduzir o custo
              do seu seguro, mas também para corrigir falhas contratuais e garantir uma proteção muito mais
              segura e eficiente para o seu patrimônio.
            </p>

            <p className="text-slate-600 text-[15px] sm:text-[16px] lg:text-[18px] leading-[1.65] max-w-[680px]">
              Mesmo durante a vigência, é possível identificar oportunidades de economia e melhorias na sua proteção.
            </p>

            {/* Lista de blocos */}
            <div className="space-y-3">
              {[
                {
                  icon: 'ri-money-dollar-circle-line',
                  title: 'Redução do custo do seguro',
                },
                {
                  icon: 'ri-file-warning-line',
                  title: 'Correção de falhas contratuais',
                },
                {
                  icon: 'ri-shield-check-line',
                  title: 'Ajuste das coberturas',
                },
                {
                  icon: 'ri-search-eye-line',
                  title: 'Análise técnica profissional',
                },
                {
                  icon: 'ri-safe-2-line',
                  title: 'Mais segurança para o seu patrimônio',
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 sm:gap-4 bg-white border border-slate-200 rounded-lg sm:rounded-xl p-4 sm:p-4.5 hover:border-blue-300 hover:bg-blue-50/20 transition-all duration-300 group"
                >
                  <div className="flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 bg-blue-50 rounded-lg flex items-center justify-center border border-blue-200 group-hover:border-blue-300 transition-colors">
                    <i className={`${item.icon} text-blue-500 text-lg sm:text-[19px]`} />
                  </div>
                  <p className="text-slate-700 font-medium text-sm sm:text-[15px] lg:text-[17px] leading-relaxed pt-1">
                    {item.title}
                  </p>
                </div>
              ))}
            </div>

            {/* Bloco IBX */}
            <div className="relative bg-white border border-slate-200 border-l-[3px] border-l-emerald-500 rounded-xl sm:rounded-2xl p-5 sm:p-6">
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="flex-shrink-0 w-11 h-11 sm:w-12 sm:h-12 bg-emerald-50 rounded-lg flex items-center justify-center border border-emerald-200">
                  <i className="ri-shield-check-line text-emerald-600 text-xl sm:text-[22px]" />
                </div>
                <div>
                  <div className="text-emerald-700 font-bold text-[10px] sm:text-[11px] uppercase tracking-[0.14em] mb-1.5">
                    Solução IBX Brasil
                  </div>
                  <p className="text-slate-800 text-[15px] sm:text-[17px] lg:text-[18px] leading-[1.55] font-semibold">
                    Com a IBX Brasil, você identifica desperdícios, corrige falhas ocultas e melhora a proteção
                    do seu seguro auto com análise técnica profissional.
                  </p>
                </div>
              </div>
            </div>

            {/* Indicadores */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {[
                { label: 'Economia', desc: 'Redução de custo possível' },
                { label: 'Contrato', desc: 'Correção de falhas' },
                { label: 'Proteção', desc: 'Cobertura mais segura' },
              ].map((item, index) => (
                <div
                  key={index}
                  className="bg-white border border-slate-200 rounded-lg p-3.5 hover:border-emerald-300 hover:bg-emerald-50/20 transition-all duration-300"
                >
                  <div className="text-emerald-700 font-bold text-[11px] sm:text-xs uppercase tracking-[0.12em] mb-1">
                    {item.label}
                  </div>
                  <div className="text-slate-500 text-[11px] sm:text-xs leading-snug">
                    {item.desc}
                  </div>
                </div>
              ))}
            </div>

            {/* Destaque escuro */}
            <div className="relative bg-slate-900 rounded-xl sm:rounded-2xl p-5 sm:p-6 shadow-[0_10px_30px_rgba(15,23,42,0.16)]">
              <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-14 sm:h-16 bg-gradient-to-b from-emerald-500 to-green-600 rounded-r" />
              <div className="flex items-start gap-3 pl-3">
                <i className="ri-double-quotes-l text-emerald-400/30 text-2xl sm:text-3xl flex-shrink-0" />
                <p className="text-white text-[15px] sm:text-[17px] lg:text-[20px] font-bold leading-[1.5]">
                  O seguro do carro não precisa esperar vencer para ser melhorado.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="pt-1">
              <a
                href="#contato"
                className="group flex sm:inline-flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white font-semibold px-6 sm:px-8 py-4 rounded-xl transition-all duration-300 w-full sm:w-auto text-center shadow-[0_10px_24px_rgba(37,99,235,0.22)]"
              >
                <i className="ri-shield-check-line text-xl shrink-0" />
                <span className="text-sm sm:text-base lg:text-[17px] leading-tight">
                  REAVALIAR MEU SEGURO AGORA
                </span>
                <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform shrink-0" />
              </a>

              <p className="text-slate-500 text-[11px] sm:text-xs mt-3 italic flex items-center justify-center sm:justify-start gap-2">
                <i className="ri-shield-star-line text-emerald-500" />
                Mesmo durante a vigência, sua apólice pode melhorar.
              </p>
            </div>
          </div>

          {/* COLUNA DIREITA */}
          <div className="relative h-full min-h-[420px] sm:min-h-[560px] lg:min-h-[960px] mt-4 lg:mt-0">
            <div className="relative h-full rounded-[20px] sm:rounded-[24px] overflow-hidden shadow-[0_18px_50px_rgba(15,23,42,0.14)]">
              <img
                src="https://images.unsplash.com/photo-1549923746-c502d488b3ea?auto=format&fit=crop&w=1200&q=80"
                alt="Pessoa analisando seguro do carro"
                className="absolute inset-0 w-full h-full object-cover"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/10 to-transparent" />

              {/* Badge superior */}
              <div className="absolute top-5 sm:top-6 right-5 sm:right-6 bg-blue-600 text-white rounded-xl px-5 py-4 border border-blue-500/50 shadow-md">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-refresh-fill text-base sm:text-lg" />
                  <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.14em] opacity-90">
                    Revisão
                  </span>
                </div>
                <div className="text-2xl sm:text-3xl font-bold leading-none">Ativa</div>
                <div className="text-[10px] sm:text-xs font-medium opacity-90 whitespace-nowrap">
                  durante a vigência
                </div>
              </div>

              {/* Card inferior */}
              <div className="absolute bottom-5 sm:bottom-6 left-5 sm:left-6 right-5 sm:right-6 bg-white rounded-xl p-5 sm:p-6 border border-slate-200 shadow-sm">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-11 h-11 sm:w-12 sm:h-12 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg flex items-center justify-center">
                    <i className="ri-search-eye-line text-white text-xl sm:text-2xl" />
                  </div>
                  <div>
                    <h4 className="text-slate-900 font-bold text-[15px] sm:text-lg mb-1">
                      Oportunidade de melhoria
                    </h4>
                    <p className="text-slate-600 text-[12px] sm:text-sm leading-relaxed">
                      Mesmo com o seguro ativo, ainda existem oportunidades de economia e melhoria da proteção.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* fim direita */}
        </div>
      </div>
    </section>
  );
};

export default ReavaliacaoSeguroAutoIBX;